import { render } from "./I18nInputText.vue?vue&type=template&id=16005e06"
import script from "./I18nInputText.vue?vue&type=script&lang=js"
export * from "./I18nInputText.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__